<template>
    <div class="absolute inset-0 pointer-events-none" :class="`${directionStyle}`" :style="{
        [isHorizontal ? 'width' : 'height']: size + 'px',
        background: `linear-gradient(to ${direction}, ${startColor} 0%, ${endColor} 65%`
    }" />
</template>

<script>
    import oppositeDirection from '@/utils/oppositeDirection'

    export default {
        props: {
            direction: { type: String, required: true },
            size: { type: Number, default: 50 },
            startColor: { type: String, default: 'rgba(255, 255, 255, 0)' },
            endColor: { type: String, default: 'rgba(255, 255, 255, 1)' },
        },

        computed: {
            isHorizontal() {
                return this.direction === 'left' || this.direction === 'right'
            },

            oppositeDirection() {
                return oppositeDirection(this.direction)
            },
            directionStyle() {
                switch(oppositeDirection(this.direction)) {
                    case 'top':
                        return 'top-auto'
                    case 'bottom':
                        return 'bottom-auto'
                    case 'left':
                        return 'left-auto'
                    case 'right':
                        return 'right-auto'
                }   
            }
        },
    }
</script>